import Vue from 'vue';
import store from './../../store';
import transTransformer from './../../transformers/productTransaction';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const transactions = transTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProductTransactions', transactions);
  resolve(transactions);
};

const failed = (error, reject) => reject();


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`products/${options.id}/transactions`, options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/transactions.js